import { render, staticRenderFns } from "./ReportsPreview.vue?vue&type=template&id=0fd45f38&scoped=true&"
import script from "./ReportsPreview.vue?vue&type=script&lang=js&"
export * from "./ReportsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPreview.vue?vue&type=style&index=0&id=0fd45f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd45f38",
  null
  
)

export default component.exports